import * as React from 'react'
import { connect } from 'react-redux'
import Chapter from 'src/components/Chapter'
import { Dispatch, RootState, store } from 'src/store'
import styled from 'styled-components'

type ILectureContentProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch>

const LectureContentContainer = styled.div`
  margin: auto;
  border-radius: 4px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
  padding: 40px;
  @media (max-width: 991px) {
    padding: 20px 16px;
    border-radius: 0px;
  }
`

const LectureContent = ({
  currentLectureId,
  currentChapterIdx,
  currentLecture,
  onChapterToggle
}: ILectureContentProps) => {
  return (
    <LectureContentContainer>
      {currentLectureId && currentLecture
        ? currentLecture.units[0].chapters.map((chapter, idx) => (
            <Chapter
              key={idx}
              lectureId={currentLectureId}
              chapterIdx={idx}
              isActive={idx === currentChapterIdx}
              onToggle={onChapterToggle.bind(null, idx)}
            />
          ))
        : null}
    </LectureContentContainer>
  )
}

const mapState = ({ lectureContent, lectures }: RootState) => {
  return {
    currentLectureId: lectureContent.currentLectureId,
    currentChapterIdx: lectureContent.currentChapterIdx,
    currentLecture: lectureContent.currentLectureId
      ? lectures[lectureContent.currentLectureId]
      : null
  }
}

const mapDispatch = (dispatch: Dispatch) => ({
  onChapterToggle: (chapterIdx: number) => {
    const rootState = store.getState()
    // collapse if click again
    if (chapterIdx === rootState.lectureContent.currentChapterIdx) {
      dispatch.lectureContent.updateLectureContentState({
        currentChapterIdx: -1,
        currentInsightId: null,
        currentMaterialIdx: -1
      })
    } else {
      dispatch.lectureContent.updateLectureContentState({
        currentChapterIdx: chapterIdx,
        currentInsightId: null,
        currentMaterialIdx: -1
      })
    }
  }
})

export default connect(
  mapState,
  mapDispatch
)(LectureContent)



// WEBPACK FOOTER //
// ./src/pages/LectureContentPage/LectureContent.tsx